export default __webpack_public_path__ + "94f96c7f9468897fb763dc09fe443c37.svg";